(function() {
    const sectionId = window.collectionInfiniteScroll && window.collectionInfiniteScroll.sectionId;
    if (!sectionId) return;

    const LIST_SEL = '#product-list-' + sectionId;
    const PAGINATION_SEL = '#CollectionPagination';

    // Lock already-revealed cards so re-initialization won't hide them again
    function lockRevealedCards() {
      const container = document.querySelector(LIST_SEL);
      if (!container) return;

      const cards = container.querySelectorAll('[reveal-on-scroll]');
      cards.forEach(function(el) {
        // Consider it "already revealed" if the theme marked it or it's visibly opaque
        const revealed = el.classList.contains('is-revealed') || getComputedStyle(el).opacity !== '0';
        if (revealed) {
          el.setAttribute('data-reveal-locked', '');
          el.removeAttribute('reveal-on-scroll');
        }
      });
    }

    // Run reveal only for the new items (which still keep the reveal-on-scroll attribute)
    function revealOnlyNewCards() {
      const productList = document.querySelector(LIST_SEL);
      if (!productList) return;

      const motionSafe = (typeof window.matchesMediaQuery === 'function')
        ? window.matchesMediaQuery('motion-safe')
        : window.matchMedia('(prefers-reduced-motion: no-preference)').matches;

      if (!motionSafe) return;

      // If the theme exposes a reveal() on the product-list element, call it.
      if (typeof productList.reveal === 'function') {
        productList.reveal();
        return;
      }

      // Fallback: trigger an event some themes listen for
      const evt = new CustomEvent('reveal:refresh', { bubbles: true });
      productList.dispatchEvent(evt);
    }

    function initAjaxinate() {
      if (!window.Ajaxinate) return;

      const pagination = document.querySelector(PAGINATION_SEL);
      const container = document.querySelector(LIST_SEL);
      if (!pagination || !container) return;

      if (window.collectionAjaxinate && typeof window.collectionAjaxinate.destroy === 'function') {
        window.collectionAjaxinate.destroy();
      }

      window.collectionAjaxinate = new Ajaxinate({
        container: LIST_SEL,
        pagination: PAGINATION_SEL,
        method: 'scroll',
        offset: 0,
        loadingText: 'Cargando...',
        callback: function() {
          if (window.initProductCards) window.initProductCards();

          // 1) Prevent re-init from hiding already visible cards
          lockRevealedCards();

          // 2) Now reveal only the newly appended cards
          //    (they still have [reveal-on-scroll] since we didn't remove it from them)
          revealOnlyNewCards();
        }
      });
    }

    document.addEventListener('DOMContentLoaded', function() {
      initAjaxinate();

      // Give the initial page a tick to reveal, then lock it so future re-inits won't hide it
      requestAnimationFrame(function(){
        setTimeout(lockRevealedCards, 50);
      });
    });

    // When filters replace content, everything is new; let it render, then lock what was revealed
    document.addEventListener('facets:updated', function() {
      initAjaxinate();
      requestAnimationFrame(function(){
        setTimeout(lockRevealedCards, 50);
      });
    });

    document.addEventListener('shopify:section:load', function() {
      initAjaxinate();
      requestAnimationFrame(function(){
        setTimeout(lockRevealedCards, 50);
      });
    });
  })();